module.exports = __webpack_public_path__ + "static/2-ab89b9d0682861df5fc48f00c8d4a14c.png";